module.exports = __webpack_public_path__ + "static/media/contactless.58eed1ac.svg";